module.exports = {
	IMAGE: "img",
	TEXT: "txt",
	LOCATION: "location",
	VIDEO: "video",
	AUDIO: "audio",
	EMOJI: "emoji",
	FILE: "file",
	CUSTOM: "custom",
	GOODS: "goods",
	BACKLIST: "backlist",
	ORDER: "order",
	CUSTOM_TYPE: {
		image: '图片',
		audio: '语音',
		video: '视频',
		file: '文件',
		goods: '商品',
		backlist: '回收列表',
		order: '订单',
		inform: '系统通知'
	},
	//
	chatType: {
		SINGLE_CHAT: "singleChat",
		CHAT_ROOM: "chatRoom"
	}
};